import { render } from "./Surtir.vue?vue&type=template&id=0ff5449c"
import script from "./Surtir.vue?vue&type=script&lang=js"
export * from "./Surtir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__